<div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
        <div class="filter-options">
            <span>Show</span>
            <select
                class="ml-2 grid-header-element number-sort-filter"
                aria-controls="catering-entries"
                name="catering-entries"
                [(ngModel)]="selectedPageEntries"
                (change)="updatePagination()"
            >
                <option *ngFor="let number of numberOfEntries" [value]="number">
                    {{ number }}
                </option>
            </select>
            <span class="ml-2">entries</span>
        </div>
    </div>
    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 px-0">
        <div class="row">
            <div class="col-lg-7"></div>
            <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
            <div class="col-lg-5">
                <div id="example1_filter" class="d-flex float-right align-items-center">
                    <span>Search</span>
                    <input
                        class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                        aria-controls="example1"
                        type="search"
                        [(ngModel)]="searchCateringLogs"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
<table id="cateringLog" class="table card-layout table-striped table mt-0">
    <thead>
        <tr>
            <td class="header_td table_heading">
                <div class="header_container text-primary">
                    <div
                        class="header_title cursorPointer col-md-1 leg-number"
                        (click)="cateringLogsSortBy = 'legSequence'; sortOrder = !sortOrder; legNumber = !legNumber"
                    >
                        Leg Number
                        <ds-icon *ngIf="legNumber" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!legNumber" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 catering-number"
                        (click)="cateringLogsSortBy = 'cateringSequence'; sortOrder = !sortOrder; cateringNumber = !cateringNumber"
                    >
                        Catering Number
                        <ds-icon *ngIf="cateringNumber" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!cateringNumber" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 origin"
                        (click)="cateringLogsSortBy = 'addressName'; sortOrder = !sortOrder; legOrigin = !legOrigin"
                    >
                        Origin
                        <ds-icon *ngIf="legOrigin" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!legOrigin" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 destination"
                        (click)="cateringLogsSortBy = 'addressName'; sortOrder = !sortOrder; legDestination = !legDestination"
                    >
                        Destination
                        <ds-icon *ngIf="legDestination" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!legDestination" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 previous-status"
                        (click)="cateringLogsSortBy = 'previousStatus'; sortOrder = !sortOrder; previousStatus = !previousStatus"
                    >
                        Previous Status
                        <ds-icon *ngIf="previousStatus" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!previousStatus" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 updated-status"
                        (click)="cateringLogsSortBy = 'currentStatus'; sortOrder = !sortOrder; updatedStatus = !updatedStatus"
                    >
                        Updated Status
                        <ds-icon *ngIf="updatedStatus" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!updatedStatus" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 created-on"
                        (click)="cateringLogsSortBy = 'createdOn'; sortOrder = !sortOrder; createdOn = !createdOn"
                    >
                        Created On
                        <ds-icon *ngIf="createdOn" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!createdOn" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 created-by"
                        (click)="cateringLogsSortBy = 'createdBy'; sortOrder = !sortOrder; createdBy = !createdBy"
                    >
                        Created By
                        <ds-icon *ngIf="createdBy" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!createdBy" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 updated-on"
                        (click)="cateringLogsSortBy = 'updatedOn'; sortOrder = !sortOrder; updatedOn = !updatedOn"
                    >
                        Updated On
                        <ds-icon *ngIf="updatedOn" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!updatedOn" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 updated-by"
                        (click)="cateringLogsSortBy = 'updatedBy'; sortOrder = !sortOrder; updatedBy = !updatedBy"
                    >
                        Updated By
                        <ds-icon *ngIf="updatedBy" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!updatedBy" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 operation-type"
                        (click)="cateringLogsSortBy = 'operationType'; sortOrder = !sortOrder; operationType = !operationType"
                    >
                        Operation Type
                        <ds-icon *ngIf="operationType" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!operationType" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 previous-values"
                        (click)="cateringLogsSortBy = 'previousValueDescription'; sortOrder = !sortOrder; previousValues = !previousValues"
                    >
                        Previous Values
                        <ds-icon *ngIf="previousValues" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!previousValues" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                    <div
                        class="header_title cursorPointer col-md-1 current-values"
                        (click)="cateringLogsSortBy = 'currentValueDescription'; sortOrder = !sortOrder; currentValues = !currentValues"
                    >
                        Current Values
                        <ds-icon *ngIf="currentValues" name="expand_less" size="inherit" class="margin-left-7"></ds-icon>
                        <ds-icon *ngIf="!currentValues" name="expand_more" size="inherit" class="margin-left-7"></ds-icon>
                    </div>
                </div>
            </td>
        </tr>
    </thead>
    <tbody>
        <tr
            *ngFor="
                let log of cateringLogs
                    | orderBy: cateringLogsSortBy : sortOrder
                    | filter: searchCateringLogs
                    | paginate: { id: 'cateringLogsPagination', itemsPerPage: selectedPageEntries, currentPage: currentPage };
                let i = index
            "
        >
            <td>
                <div class="row_container">
                    <div class="title_container col-md-1 leg-number">
                        <div class="row_title">Leg Number</div>
                        <div class="row_detail">
                            {{ log.legSequence }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 catering-number">
                        <div class="row_title">Catering Number</div>
                        <div class="row_detail">
                            {{ log.cateringSequence }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 origin">
                        <div class="row_title">Origin</div>
                        <div class="row_detail">
                            <b>{{ log?.legOrigin?.addressName }}</b>
                            <br />
                            {{ log?.legOrigin?.streetAddress }}
                            {{ log?.legOrigin?.city }},
                            {{ log?.legOrigin?.zipCode }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 destination">
                        <div class="row_title">Destination</div>
                        <div class="row_detail">
                            <b>{{ log?.legDestination?.addressName }}</b>
                            <br />
                            {{ log?.legDestination?.streetAddress }}
                            {{ log?.legDestination?.city }},
                            {{ log?.legDestination?.zipCode }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 previous-status">
                        <div class="row_title">Previous Status</div>
                        <div class="row_detail">
                            <div *ngIf="log.previousStatus; else elseBlock">
                                {{ log.previousStatus }}
                            </div>
                            <ng-template #elseBlock> NA </ng-template>
                        </div>
                    </div>
                    <div class="title_container col-md-1 updated-status">
                        <div class="row_title">Updated Status</div>
                        <div class="row_detail">
                            {{ log.currentStatus }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 created-on">
                        <div class="row_title">Created On</div>
                        <div class="row_detail">
                            {{ log.createdOn | localDate }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 created-by">
                        <div class="row_title">Created By</div>
                        <div class="row_detail">
                            {{ log.createdBy }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 updated-on">
                        <div class="row_title">Updated On</div>
                        <div class="row_detail">
                            {{ log.updatedOn | localDate }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 updated-by">
                        <div class="row_title">Updated By</div>
                        <div class="row_detail">
                            {{ log.updatedBy }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 operation-type">
                        <div class="row_title">Operation Type</div>
                        <div class="row_detail">
                            {{ log.operationType }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 previous-values">
                        <div class="row_title">Previous Values</div>
                        <div class="row_detail">
                            <ng-container *ngIf="log.previousValueDescription; else elseBlock">
                                <ng-container *ngFor="let previousDetail of log.previousValueDescription">
                                    <div>{{ previousDetail }}</div>
                                </ng-container>
                            </ng-container>
                            <ng-template #elseBlock> NA </ng-template>
                        </div>
                    </div>
                    <div class="title_container col-md-1 current-values">
                        <div class="row_title">Current Values</div>
                        <div class="row_detail">
                            <ng-container *ngFor="let currentDetail of log.currentValueDescription">
                                <div>{{ currentDetail }}</div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
</table>
<div *ngIf="cateringLogs?.length == 0" class="text-color"><b>No Record Available</b></div>
<div *ngIf="cateringLogs?.length != 0" class="col-md-12 p-0">
    <div id="left" class="col-md-6 p-0">
        {{ pagination }}
    </div>

    <div id="catering" class="col-md-6 pagination text-end">
        <pagination-controls
            id="cateringLogsPagination"
            nextLabel=""
            previousLabel=""
            [responsive]="true"
            (pageChange)="currentPageChange($event)"
        >
        </pagination-controls>
    </div>
</div>
